module.exports = __webpack_public_path__ + "static/media/error_image.9ce7f344.svg";